import React, { useState } from "react";
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

const InputMaskEIN = React.forwardRef(function InputMaskEIN(props, ref) {
  const { inputRef, onChange, onFocus, onBlur, ...inputMaskProps } = props;
   const [focused, setFocused] = useState(false);
   const [hasValue, setHasValue] = useState(false);

  return (
    <IMaskInput
      {...inputMaskProps}
      inputRef={ref || inputRef}
      mask="00-0000000"
      lazy={!focused && !hasValue}
      placeholderChar="_"
      onAccept={(value) => {
        const digits = value.replace(/[^0-9]/g, '');
        setHasValue(digits.length > 0);
        onChange({
          target: {
            name: props.name,
            value: value,
          },
        });
      }}
      onFocus={(e) => {
        setFocused(true);
        if (onFocus) onFocus(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        const digits = e.target.value.replace(/[^0-9]/g, '');
        const isEmpty = digits.length === 0;
        setHasValue(!isEmpty);
        
        if (isEmpty) {
          e.target.value = '';
          onChange({
            target: {
              name: props.name,
              value: '',
            },
          });
        }
        
        if (onBlur) onBlur(e);
      }}
    />
  );
});

InputMaskEIN.propTypes = {
  inputRef: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
}

export default InputMaskEIN;
